export { LoyaltyHomeFooter } from './LoyaltyHomeFooter';
